import { createClient } from '@supabase/supabase-js';

// Utiliser directement les variables d'environnement comme dans lib/supabase.ts
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables');
  throw new Error('Missing Supabase environment variables');
}

const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  }
});

// Test the connection dans une fonction IIFE pour éviter le top-level await
(async function testConnection() {
  try {
    const { data, error } = await supabase.from('contests').select('count');
    if (error) {
      console.error('Database connection failed:', error);
      return;
    }
    console.info('Database connected successfully');
  } catch (err) {
    console.error('Database connection error:', err);
  }
})();

export { supabase };